// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup[data-v-467677f4]{width:180px}.popup .popup-title[data-v-467677f4]{display:inline-block;line-height:1em;color:#333;font-size:1em;margin:0;padding:0;white-space:nowrap}.popup .popup-content[data-v-467677f4]{position:relative;width:100%}.popup[data-v-467677f4] .buttons{display:flex}\n", ""]);
// Exports
module.exports = exports;
